export default __webpack_public_path__ + "static/media/twit.536757c2.png";